import Helpers from '../mixins/Helpers';
import { version } from '../../package';

export default {
	mixins: [Helpers],
	data() {
		return {
			appVersion: version,
			//
			useCache: localStorage.getItem('useLocalCache') !== null
				? localStorage.getItem('useLocalCache') === 'true'
				: true,
			//
			useCachedEndpoints: localStorage.getItem('useCachedEndpoints') !== null
				? localStorage.getItem('useCachedEndpoints') === 'true'
				: true,
			cachedBlacklist: ["/VerifiedEmails/", "/logo", "/Documents/", "/Achievements/Points", "/Achievements", "/Quizzes", "/Chats/Messages", "/CMS", "/Payments"],
			api: null,
			configUri: null,
			customer: null,
			customerTags: [],
			customerTagTransactions: [],
			employer: null,
			bankInfo: null,
			bankAccount: null,
			insuranceInfo: null,
			insuranceProviders: null,
			investmentProviders: null,
			mortgageInfo: null,
			investmentInfo: null,
			creditInfo: null,
			documents: null,
			investmentAccount: null,
			articles: null,
			article: null,
			disabledFeatures: [],
			enabledFeatures: [],
			spendingAnalysis: null,
			spendingAnalysisStructured: null,
			spendingPlans: [],
			spendingPlansFull: [],
			availableVouchers: null,
			availableVoucher: null,
			favouriteDiscounts: null,
			vouchers: null,
			groupedVouchers: null,
			vouchersSummary: null,
			voucher: null,
			categories: [],
			creditTypes: [],
			creditProviders: [],
			plans: null,
			plan: null,
			planSection: null,
			planTask: null,
			products: [],
			marketplace: [],
			benefits: [],
			calculators: [],
			notifications: null,
			payment: null,
			policyTypes: [],
			savingGoals: null,
			investmentTypes: [],
			financialFitness: null,
			config: null,
			token: null,
			completedMoves: null,
			pendingMoves: null,
			customerMove: null,
			transaction: null,
			suggestedClassification: null,
			transactions: [],
			questionnaire: null,
			quizzes: null,
			quizPoints: null,
			quizAnswers: null,
			policy: null,
			creditAccount: null,
			randomiseFigures: false,
			points: null,
			sectionJson: null,
			formatter: {
				original: new Intl.NumberFormat('en-GB', {
					style: 'currency',
					currency: 'GBP',
					trailingZeroDisplay: 'auto',
				}),
				format(value, short = false, trailingZeroDisplay = true) {
					if (this.randomiseFigures == undefined || this.randomiseFigures == null) {
						this.randomiseFigures = localStorage.getItem('randomiseFigures') === 'true' ? true : false
					}
					if (this.randomiseFigures) {
						// var temp = this.original.format(value);
						// var ret = temp.replace(/\d/g, '#');
						// return ret;
						if (!short) {
							return "£####";
						}
						else {
							return "£#";
						}

					}

					// Create NumberFormat with optional trailingZeroDisplay
					const options = {
						style: 'currency',
						currency: 'GBP'
					};

					if (trailingZeroDisplay !== undefined) {
						options.trailingZeroDisplay = trailingZeroDisplay ? 'auto' : 'stripIfInteger';
					}

					return new Intl.NumberFormat('en-GB', options).format(value);
				},
			},
			dateFormatPretty: new Intl.DateTimeFormat('en-GB', {
				day: '2-digit',
				month: 'short',
				year: 'numeric'
			}),
			timeOfDay: new Date().getHours() < 12 ? 'Morning' : new Date().getHours() < 18 ? 'Afternoon' : 'Evening',
			today: new Date().toLocaleDateString('en-GB', {
				day: '2-digit',
				month: 'short'
			}),
			yesterday: new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString('en-GB', {
				day: '2-digit',
				month: 'short'
			}),
			menuShown: this.$route.meta.bottomMenu,
			bottomMenuHeight: 76,
			drawerBottom: this.$route.meta.bottomMenu ? 46 : -23,
			aiopSectionsS3Bucket: "https://s3.eu-west-2.amazonaws.com/aiop-configs.sysodev.link/",
			aiopSections: null,
		}
	},

	created: function () {
		this.api = this.$route.meta.api;
		this.configUri = this.$route.meta.configUri;
		if (this.$route.query.st) {
			this.$cookies.set('st', this.$route.query.st, '1m');
		}
		if (this.$route.meta.authenticated == undefined || this.$route.meta.authenticated) {
			if (this.$route.query.u) {
				this.$cookies.set('user', this.$route.query.u, '1m');
				this.$cookies.set('pass', this.$route.query.p, '1m');
				this._login(this.$route.query.u, this.$route.query.p);
			}
			else if (this.$cookies.get('token')) {
				this.token = this.$cookies.get('token');
				this.$http.defaults.headers.common = { "Authorization": "bearer " + this.token };
			}
			else if (this.$cookies.get('user')) {
				this._login(this.$cookies.get('user'), this.$cookies.get('pass'));
			}
			else if (this.$route.query.t) {
				this.token = this.$route.query.t;
				this.$cookies.set('token', this.token, '30min');
				this.$http.defaults.headers.common = { "Authorization": "bearer " + this.token };
			}
			else {
				this.$router.push({ path: '/Login', query: { landingpage: this.$route.path } });
			}
		}
	},

	methods: {

		_openV1: function (path, returnPath = null) {
			if (!returnPath) { returnPath = '#' }
			//console.log(returnPath, 'returnPath');
			//console.log(window.location.origin, 'origin');
			window.location.href = "/MG_NAV_" + path + "_";
			setTimeout(() => {
				window.location = window.location.origin + '/#/' + returnPath;
			}, 500);
		},

		_signalV1: function (op, val, val2, val3, returnPath = null) {
			if (!returnPath) { returnPath = '#' }
			//console.log(returnPath, 'returnPath');
			//console.log(window.location.origin, 'origin');
			window.location.href = "/MG_SIG_" + op + "_" + val + "_" + val2 + "_" + val3 + "_";
			setTimeout(() => {
				window.location = window.location.origin + '/#/' + returnPath;
			}, 500);
		},

		_GET: function (url, onSuccess, useCache = false, forceSetCache = false, ttlMins = 3, retrying = false) {
			url = url.replace(/\/+$/, ''); // Remove trailing slashes
			if (this.useCachedEndpoints && !url.toLowerCase().includes('/cached/')) {
				if (!this.cachedBlacklist.some(endpoint => url.includes(endpoint))) {
					url = "/Cached" + url;
				}
			}
			if (!url.includes(this.api)) {
				url = this.api + url;
			}
			if (useCache) {
				var fromCache = this._getFromCache(url);
				var attempts = 0;
				// If another process has already invoked the GET request, wait for it to finish
				if (fromCache) {
					if (fromCache === 'loading') {
						const interval = setInterval(() => {
							console.log('Waiting for cache to update...', url);
							const updatedCache = this._getFromCache(url);
							// If the cache is updated, clear the interval and call onSuccess
							if (updatedCache && updatedCache !== 'loading') {
								clearInterval(interval);
								if (onSuccess) {
									onSuccess(updatedCache);
								}
							}
							attempts++;
							// If it's taking too long (14 x 500ms = 7 seconds), then clear the cache and try again
							if (attempts > 14) {
								console.log('too many tries');
								clearInterval(interval);
								localStorage.removeItem(url);
								this._GET(url, onSuccess, useCache, forceSetCache);
							}
						}, 500); // check every 200ms
						return;
					}
					if (onSuccess) {
						onSuccess(fromCache);
					}
					return;
				}
			}
			if (forceSetCache) {
				this._cache(url, 'loading', ttlMins);
			}
			this.$http.get(url)
				.then((result) => {
					if (useCache || forceSetCache) { this._cache(url, result.data, ttlMins); }
					if (onSuccess) {
						onSuccess(result.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401 && !retrying) {
						this._refreshLogin(() => {
							this._GET(url, onSuccess, useCache, forceSetCache, ttlMins, true);
						});
					}
					else if (result.response.status == 401 && retrying) {
						console.error('Retrying GET request failed due to unauthorized access:', url);
					}
				});
		},

		_getFromCache: function (url) {
			if (!this.useCache) { return null; }
			var cache = localStorage.getItem(url);
			if (!cache) { return null; }
			cache = JSON.parse(cache);
			if (cache.expires > new Date()) {
				return cache.data;
			}
			return null;
		},

		_cache: function (url, data, ttlMins = 3) {
			if (!this.useCache) { return; }
			try {
				localStorage.setItem(url, JSON.stringify({
					data: data,
					expires: new Date().setMinutes(new Date().getMinutes() + ttlMins)
				}));
			}
			catch (e) {
				console.log(e, 'Caching error');
				localStorage.clear();
			}
		},

		_clearExpiredCaches: function () {
			for (var i = localStorage.length - 1; i >= 0; i--) {
				var key = localStorage.key(i);
				if (key.startsWith(this.api)) {
					var cache = JSON.parse(localStorage.getItem(key));
					if (cache && cache.expires != undefined) {
						if (cache.expires < new Date()) {
							localStorage.removeItem(key);
						}
					}
				}
			}
		},

		_enableWhatsApp: function () {
			var request = {
				"title": "welcome_to_mg",
				"whatsApp": true,
				"whatsAppTemplate": true,
				"phoneNumber": this.customer.person.mobilePhone
			};
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Notifications", request)
				.then(() => {
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._enableWhatsApp();
						});
					}
				});
		},

		_sendWhatsAppNotification: function (body, phoneNumber, onSuccess = null) {
			var request = {
				"body": body,
				"whatsApp": true,
				"whatsAppTemplate": false,
				"phoneNumber": phoneNumber
			};
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Notifications", request)
				.then(() => {
					if (onSuccess) {
						onSuccess();
					}
				})
				.catch((result) => {
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._sendWhatsAppNotification(body, phoneNumber, onSuccess);
						});
					}
				});
		},

		_getInterestRateType: function (interestRateType) {
			if (interestRateType == null) { return null; }
			if (interestRateType == 0) return "Fixed";
			if (interestRateType == 1) return "Standard Variable";
			if (interestRateType == 2) return "Discounted Tracker";
			return "Unknown";
		},

		_calculateMonthsRemaining: function (endDate) {
			const now = new Date();
			const end = new Date(endDate);
			const years = end.getFullYear() - now.getFullYear();
			const months = end.getMonth() - now.getMonth();
			return years * 12 + months;
		},

		_calculateDateProgressPercentage: function (start, end) {
			const now = new Date();
			const startDate = new Date(start);
			const endDate = new Date(end);
			const total = endDate - startDate;
			const elapsed = now - startDate;
			return Math.round((elapsed / total) * 100);
		},

		_savePreferences: function (onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Preferences", this.customer.preferences)
				.then((result) => {
					this.customer = result.data;
					this._clearCustomer();
					if (onSuccess) {
						onSuccess();
					}
				})
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._savePreferences(onSuccess);
						});
					}
				});
		},

		_versionAssertion: function () {
			if (this.config.vueAppVersion != this.appVersion) {
				if (!this.$cookies.get('block_version_reload')) {
					//console.log("Version mismatch. App version: " + this.appVersion + ", Config version: " + this.config.version);
					this.$cookies.set('block_version_reload', null, '5min');
					window.location.reload();
				}
			}
		},

		_getAppConfig: function (onSuccess = null) {
			var orig = this.$http.defaults.headers.common;
			this.$http.defaults.headers.common = null;
			this.$http.get("https://s3.eu-west-2.amazonaws.com/config.moneyguided.com/" + this.configUri + "_config.json")
				.then((result) => {
					this.config = result.data;
					//console.log(this.config, "App config");
					this._versionAssertion();
					if (onSuccess) {
						onSuccess();
					}
				})
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._getAppConfig(onSuccess);
						});
					}
				});
			this.$http.defaults.headers.common = orig;
		},

		_getNotifications: function (onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Notifications", (result) => {
				this.notifications = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ true);
		},
		_clearNotificationCache: function () {
			localStorage.removeItem(this.api + (this.useCachedEndpoints ? '/Cached' : '') + '/Customers/00000000-0000-0000-0000-000000000000/Notifications');
		},

		_markAsDeleteNotification: function (notificationId, onSuccess = null) {
			this.$http.delete(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Notifications/" + notificationId)
				.then(() => {
					if (onSuccess) {
						onSuccess();
					}
				})
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._markAsDeleteNotification(notificationId, onSuccess);
						});
					}
				});
		},

		_getPoints: function (onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Achievements/Points", (result) => {
				this.points = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ false);
		},

		_getAchievements: function (onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Achievements", (result) => {
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ false);
		},

		_getCustomer: function (onSuccess = null, useCache = true) {
			if (!this.customer || !useCache) {
				this._GET("/Customers/00000000-0000-0000-0000-000000000000?getFacts=false", (result) => {
					this.customer = result;
					if (onSuccess) {
						onSuccess();
					}
				}, /* useCache: */ useCache);
			} else {
				if (onSuccess) {
					onSuccess();
				}
			}
		},

		_clearCustomer: function () {
			localStorage.removeItem(this.api + (this.useCachedEndpoints ? '/Cached' : '') + '/Customers/00000000-0000-0000-0000-000000000000?getFacts=false');
			localStorage.removeItem(this.api + (this.useCachedEndpoints ? '/Cached' : '') + '/Customers/00000000-0000-0000-0000-000000000000?getFacts=true');
		},

		_registerCustomer: function (customer, password, accessToken, onSuccess = null) {
			this.$http.post(this.api + '/Customers?createUser=true&password=' + encodeURIComponent(password) + '&verifyEmail=true' + (accessToken != null ? '&licenseToken=' + encodeURIComponent(accessToken) : ''), customer)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					console.log(result, 'ERROR CAUGHT');
				});
		},

		_verifyEmail: function (email, code, onSuccess = null) {
			var req = {
				email: email,
				code: code
			}
			this.$http.post(this.api + '/AccountConfirmations', req)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					console.log(result, 'ERROR CAUGHT');
				});
		},

		_verifyToken: function (token, onSuccess = null) {
			this.$http.get(this.api + "/Licenses/" + token)
				.then((result) => {
					if (onSuccess) {
						onSuccess(result.data);
					}
				}
				)
				.catch(() => {
					onSuccess(null);
				});
		},

		_getEmployer: function (employerId, onSuccess = null) {
			if (!this.employer) {
				this._GET("/Employers/" + employerId, (result) => {
					this.employer = result;
					if (onSuccess) {
						onSuccess();
					}
				}, /* useCache: */ true);
			} else {
				if (onSuccess) {
					onSuccess();
				}
			}
		},

		// _getPaymentFrequencies: function(onSuccess = null) {
		// 	this._GET("/PaymentFrequencies", (result) => {
		// 		if (onSuccess) {
		// 			onSuccess(result);
		// 		}
		// 	}, /* useCache: */ true);
		// },

		_setupSpendingCycle: function (customerId, cycleId, day, autoAdjust, onSuccess = null) {
			var body = {
				id: "00000000-0000-0000-0000-000000000000",
				frequency: {
					id: cycleId,
					type: 0,
					workingDayBefore: autoAdjust,
					workingDayAfter: false
				},
				dayOfWeek: 0,
				day: day,
				month: 0
			};
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Spending/Cycles", body)
				.then(() => {
					if (onSuccess) {
						onSuccess();
					}
				})
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._setupSpendingCycle(customerId, cycleId, day, autoAdjust, onSuccess);
						});
					}
				});
		},

		_getEmployerLogo: function (employerId, onSuccess = null) {
			this._GET("/Employers/" + employerId + '/logo', (result) => {
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		// _getFeatures: function(onSuccess = null) {
		// 	this._getEmployer(this.customer.employerID, () => {
		// 		this._parseFeatures();
		// 		if (onSuccess) {
		// 			onSuccess();
		// 		}
		// 	})
		// 	.catch((result) => {
		// //console.log(result, 'ERROR CAUGHT');		
		// if (result.response.status == 401) {
		// 			this._refreshLogin(() => {
		// 				this._getFeatures(onSuccess);
		// 			});
		// 		}
		// 	});
		// },

		// _parseFeatures: function() {
		// 	this.disabledFeatures = [];
		// 	this.enabledFeatures = [];
		// 	for (var x = 0; x < this.employer.features.length; x++) {
		// 		if (!this.employer.features[x].enabled) {
		// 			this.disabledFeatures.push(this.employer.features[x].feature.name);
		// 		} else {
		// 			this.enabledFeatures.push(this.employer.features[x].feature.name);
		// 		}
		// 	}
		// 	//console.log(this.disabledFeatures);
		// 	//console.log(this.enabledFeatures);
		// },

		_validateEmployer: function (email, onSuccess = null) {
			var req = { email: email };
			this.$http.post(this.api + "/EmployerValidationRequests", req)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				);
		},

		_emailIsVerified: function (verificationId, onSuccess = null) {
			this._GET("/VerifiedEmails/" + verificationId, (result) => {
				//console.log(result, 'Email verification result');
				if (result) {
					if (onSuccess) {
						onSuccess();
					}
				}
			});
		},

		_getProducts: function (employerId, onSuccess = null) {
			this.products = [];
			if (employerId) { this.benefits = []; }
			this.calculators = [];
			this.marketplace = [];
			this._GET("/Products" + (employerId ? "?employerId=" + employerId : ""), (result) => {
				this.products = result;
				for (var x = 0; x < this.products.length; x++) {
					if (this.products[x].thumbnail.startsWith("Logos/")) {
						this.products[x].thumbnail = this.products[x].thumbnail.replace('Logos/', 'https://s3.eu-west-2.amazonaws.com/content.sysodev.link/Logos/')
					}
					this.products[x].img = this.products[x].thumbnail;
					if (employerId != null && this.products[x].tags.includes("employeeBenefit")) {
						this.benefits.push(this.products[x]);
					}
					if (this.products[x].tags.includes("calculator")) {
						this.calculators.push(this.products[x]);
					}
					if (this.products[x].tags.includes("marketplace")) {
						this.marketplace.push(this.products[x]);
					}
				}
				//console.log(this.products);
				//console.log(this.benefits);
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ true);
		},

		_getProduct: function (productId, onSuccess = null) {
			this._GET("/Products/" + productId, (result) => {
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_getCompletedMoves: function (onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/CompletedMoves", (result) => {
				this.completedMoves = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_getPendingMoves: function (onSuccess = null, groupFiltered = false) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Moves", (result) => {
				this.pendingMoves = result;
				if (this.pendingMoves == null) { this.pendingMoves = []; }
				this.pendingMoves = this.pendingMoves.filter(move => move.move.enabled !== false);
				if (groupFiltered) {
					var pendingMovesGrouped = this.pendingMoves.reduce((groups, move) => {
						if (!groups[move.move.appScreen]) {
							groups[move.move.appScreen] = [];
						}
						groups[move.move.appScreen].push(move);
						return groups;
					}, {});
					this.pendingMoves = [];
					for (const key in pendingMovesGrouped) {
						this.pendingMoves.push(pendingMovesGrouped[key][0]);
					}
				}
				if (onSuccess) {
					onSuccess(this.pendingMoves);
				}
			}
				, /* useCache: */ true);
		},

		_getCustomerMove: function (moveId, onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Moves/" + moveId, (result) => {
				this.customerMove = result;
				if (onSuccess) {
					onSuccess(result);
				}
			},
			/* useCache: */ true);
		},
		_clearMoves: function () {
			localStorage.removeItem(this.api + (this.useCachedEndpoints ? '/Cached' : '') + '/Customers/00000000-0000-0000-0000-000000000000/Moves');
			localStorage.removeItem(this.api + (this.useCachedEndpoints ? '/Cached' : '') + '/Customers/00000000-0000-0000-0000-000000000000/CompletedMoves');
		},

		_markCustomerMoveAsSeen: function (moveId, onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Moves/" + moveId + "/MarkAsSeenRequests", null)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._markCustomerMoveAsSeen(moveId, onSuccess);
						});
					}
				});
		},

		_markCustomerMoveAsActioned: function (moveId, onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Moves/" + moveId + "/MarkAsActionedRequests", null)
				.then((response) => {
					this._clearMoves();
					if (onSuccess) {
						onSuccess(response);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._markCustomerMoveAsActioned(moveId, onSuccess);
						});
					}
				});
		},

		_getBankingInfo: function (onSuccess = null, refreshCache = false, daysHistory = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/Info?lite=false" + (daysHistory ? "&daysHistory=" + daysHistory : ""), (result) => {
				this.bankInfo = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ !refreshCache, /* forceSetCache: */ refreshCache);
		},
		_clearBankingInfo: function () {
			localStorage.removeItem(this.api + (this.useCachedEndpoints ? '/Cached' : '') + '/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/Info?lite=false');
		},

		_searchTransactions: function (search, onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Transactions/TransactionSearches?search=" + search, null)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._searchTransactions(search, onSuccess);
						});
					}
				});
		},

		_reLinkAllBankAccounts: function (onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/ExtendAllConnectionsRequests", null)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._reLinkAllBankAccounts(onSuccess);
						});
					}
				});
		},

		_getRecurringPayments: function (onSuccess = null, refreshCache = false) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/RecurringPayments", (result) => {
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ !refreshCache, /* forceSetCache: */ refreshCache);
		},

		_getTransactionClassifications: function (onSuccess = null) {
			this._GET("/TransactionClassifications?lite=true&hierarchical=true", (result) => {
				this.transactionClassifications = result;
				if (onSuccess) {
					onSuccess(this.transactionClassifications);
				}
			}, /* useCache: */ true);
		},

		_updateBulkTransactionClassifications: function (transactions, selectedClassification, onSuccess = null) {
			var transactionIDs = transactions.value.map(transaction => transaction.id);
			var body = {
				transactionIDs: transactionIDs,
				newClassificationID: selectedClassification.id
			};
			this.$http.post(this.api + "/Customers/Transactions/BulkUntagged/BulkTagRequests?updateCustomerClassification=true", body)
				.then(() => {
					if (onSuccess) {
						onSuccess();
					}
				}
				)
				.catch((result) => {
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._updateBulkTransactionClassifications(transactions, selectedClassification, onSuccess);
						});
					}
				});
		},

		_updateTransactionClassification: function (transaction, onSuccess = null) {
			this.$http.put(this.api + "/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/Transactions/" + transaction.id, transaction)
				.then(() => {
					if (onSuccess) {
						onSuccess();
					}
				}
				)
				.catch((result) => {
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._updateTransactionClassification(transaction, onSuccess);
						});
					}
				});
		},

		_updateTransactionClassificationMerchantRule: function (transaction, onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/CustomerMerchantRules", transaction)
				.then(() => {
					if (onSuccess) {
						onSuccess();
					}
				}
				)
				.catch((result) => {
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._updateTransactionClassificationMerchantRule(transaction, onSuccess);
						});
					}
				});
		},

		_addSpendingPlan: function (plan, onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Spending/Plans", plan)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._addSpendingPlan(plan, onSuccess);
						});
					}
				});
		},

		_deleteSpendingPlan: function (id, onSuccess = null) {
			this.$http.delete(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Spending/Plans/" + id)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._deleteSpendingPlan(id, onSuccess);
						});
					}
				});
		},

		_listBanks: function (onSuccess = null) {
			this._GET("/Banks", (result) => {
				if (onSuccess) {
					onSuccess(result);
				}
			});
		},

		_linkBankAccount: function (customerId) {
			var url = this._getOpenBankingLinkUrl(customerId);
			window.location = url;
		},

		_getOpenBankingLinkUrl: function (customerId) {
			return 'https://auth.truelayer.com/?response_type=code&client_id=moneyguided-cdfa82&scope=info%20accounts%20balance%20cards%20transactions%20direct_debits%20standing_orders%20offline_access&redirect_uri=' + this.api + '/BankingGrants&providers=uk-ob-all%20uk-oauth-all&state=' + customerId;
		},

		_addOfflineBankAccount: function (account, onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/BankAccounts", account)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._addOfflineBankAccount(account, onSuccess);
						});
					}
				});
		},

		_deleteBankAccount: function (id, onSuccess = null) {
			this.$http.delete(this.api + "/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/" + id)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._deleteBankAccount(id, onSuccess);
						});
					}
				});
		},

		_updateOfflineBankAccount: function (account, onSuccess = null) {
			this.$http.put(this.api + "/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/" + account.id, account)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._updateOfflineBankAccount(account, onSuccess);
						});
					}
				});
		},

		_addPolicy: function (policy, onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Policies", policy)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._addPolicy(policy, onSuccess);
						});
					}
				});
		},

		_updatePolicy: function (policy, onSuccess = null) {
			this.$http.put(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Policies/" + policy.id, policy)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._updatePolicy(policy, onSuccess);
						});
					}
				});
		},

		_addInvestment: function (investment, onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/InvestmentHubAccounts", investment)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._addInvestment(investment, onSuccess);
						});
					}
				});
		},

		_updateInvestment: function (investment, onSuccess = null) {
			this.$http.put(this.api + "/Customers/00000000-0000-0000-0000-000000000000/InvestmentHubAccounts/" + investment.id, investment)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._updateInvestment(investment, onSuccess);
						});
					}
				});
		},

		_addCreditAccount: function (credit, onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts", credit)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._addCreditAccount(credit, onSuccess);
						});
					}
				});
		},

		_updateCreditAccount: function (credit, onSuccess = null) {
			this.$http.put(this.api + "/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts/" + credit.id, credit)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._updateCreditAccount(credit, onSuccess);
						});
					}
				});
		},

		_getCreditAccount: function (id, onSuccess = null, refreshCache = false) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts/" + id, (result) => {
				this.creditAccount = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ !refreshCache, /* forceSetCache: */ refreshCache);
		},

		_getCreditInfo: function (onSuccess = null, refreshCache = false) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts", (result) => {
				this.creditInfo = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ !refreshCache, /* forceSetCache: */ refreshCache);
		},

		_deleteCreditAccount: function (id, onSuccess = null) {
			this.$http.delete(this.api + "/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts/" + id)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._deleteCreditAccount(id, onSuccess);
						});
					}
				});
		},

		_addMortgageAccount: function (mortgage, onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts/Mortgages", mortgage)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._addMortgageAccount(mortgage, onSuccess);
						});
					}
				});
		},

		_deleteMortgageAccount: function (id, onSuccess = null) {
			this.$http.delete(this.api + "/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts/Mortgages/" + id)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._deleteMortgageAccount(id, onSuccess);
						});
					}
				});
		},

		_updateMortgageAccount: function (mortgage, onSuccess = null) {
			//console.log('update mortgage', mortgage);
			this.$http.put(this.api + "/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts/Mortgages/" + mortgage.id, mortgage)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._updateMortgageAccount(mortgage, onSuccess);
						});
					}
				});
		},

		_getPolicyTypes: function (onSuccess = null) {
			this._GET("/PolicyTypes", (result) => {
				this.policyTypes = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_getInvestmentTypes: function (onSuccess = null) {
			this._GET("/InvestmentTypes", (result) => {
				this.investmentTypes = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_getCreditTypes: function (onSuccess = null) {
			this._GET("/CreditTypes", (result) => {
				this.creditTypes = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_getCreditProviders: function (onSuccess = null) {
			this._GET("/CreditProviders", (result) => {
				this.creditProviders = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_lookupAddress: function (postCode, houseNumber, onSuccess = null) {
			var req = {
				postCode: postCode,
				house: houseNumber
			}
			var headers = this.$http.defaults.headers.common;
			this.$http.defaults.headers.common = { "Authorization": "c8f9f85f-2d53-46ba-a2b3-8cef87c7ab93" };
			this.$http.post(this.api + "/Addresses/AddressLookupRequests", req)
				.then((response) => {
					this.$http.defaults.headers.common = headers;
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch(() => {
					this.$http.defaults.headers.common = headers;
					if (onSuccess) {
						var emptyAddress = {
							addresses: [],
							success: true,
							count: 0
						};
						onSuccess(emptyAddress);
					}
				});
			this.$http.defaults.headers.common = headers;
		},

		_getBankAccount: function (id, onSuccess = null, lite = false, refreshCache = false) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/" + id + "?lite=" + lite + "&groupTransactions=true&limitTransactions=true", (result) => {
				this.bankAccount = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ !refreshCache, /* forceSetCache: */ refreshCache);
		},

		_getTransaction: function (id, onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/Transactions/" + id, (result) => {
				this.transaction = result;
				if (onSuccess) {
					onSuccess(this.transaction);
				}
			});
		},

		_getTransactions: function (classificationId, from, to, onSuccess = null, includeChildrenClassifications = false, refreshCache = false, includeExcludedFromAnalysis = true) {
			var todate = to.split('T')[0] + "T23:59:59";
			var uri = "/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/Transactions?classificationId=" + classificationId + "&from=" + from + "&to=" + todate + "&includeChildrenClassifications=" + includeChildrenClassifications;
			if (!includeExcludedFromAnalysis) {
				uri += "&includeExcludedFromAnalysis=" + includeExcludedFromAnalysis;
			}
			this._GET(uri, (result) => {
				this.transactions = result;
				//console.log(this.transactions, 'Transactions');
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ !refreshCache, /* forceSetCache: */ refreshCache);
		},
		_clearTransactionsCache: function () {
			for (let i = 0; i < localStorage.length; i++) {
				const key = localStorage.key(i);
				if (key && key.includes('BankAccounts/Transactions?classificationId')) {
					console.log('Removing cache:', key);
					localStorage.removeItem(key);
					i--; // Adjust the index after removing an item
				}
			}
		},

		_getSuggestedClassification: function (merchant, onSuccess = null, refreshCache = false) {
			var uri = "/Customers/Transactions/Vendors/ClassificationSuggestions?merchant=" + encodeURIComponent(merchant);
			this._GET(uri, (result) => {
				this.suggestedClassification = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ !refreshCache, /* forceSetCache: */ refreshCache);
		},

		_getSpendingAnalysisStructured: function (onSuccess = null, refreshCache = false, cleareCache = false) {
			const fromDate = this._getBeginningOfPreviousYear();
			const toDate = new Date();
			toDate.setUTCHours(0, 0, 0, 0); // Set time to midnight
			const fromDateString = fromDate.toISOString().split('T')[0];
			const toDateString = toDate.toISOString().split('T')[0];
			const url = this.api + (this.useCachedEndpoints ? '/Cached' : '') + `/Customers/00000000-0000-0000-0000-000000000000/Spending/Analysis/Structured?from=${fromDateString}&to=${toDateString}`;
			if (cleareCache) {
				localStorage.removeItem(url);
				return;
			}
			this._GET(url, (result) => {
				this.spendingAnalysisStructured = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ !refreshCache, /* forceSetCache: */ refreshCache, 30);
		},

		_clearSpendingAnalysis: function () {
			for (let i = 0; i < localStorage.length; i++) {
				const key = localStorage.key(i);
				if (key && key.includes('/Customers/00000000-0000-0000-0000-000000000000/Spending/Analysis')) {
					localStorage.removeItem(key);
					i--;
				}
			}
		},

		_getSpendingPlansLite: function (onSuccess = null, refreshCache = false, clearCache = false) {
			var uri = this.api + (this.useCachedEndpoints ? '/Cached' : '') + "/Customers/00000000-0000-0000-0000-000000000000/Spending/Plans?lite=true";
			if (clearCache) {
				localStorage.removeItem(uri);
				return;
			}
			this._GET(uri, (result) => {
				this.spendingPlans = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ !refreshCache, /* forceSetCache: */ refreshCache);
		},

		_getSpendingPlansFull: function (onSuccess = null, refreshCache = false, clearCache = false) {
			var uri = this.api + (this.useCachedEndpoints ? '/Cached' : '') + "/Customers/00000000-0000-0000-0000-000000000000/Spending/Plans?lite=false";
			if (clearCache) {
				localStorage.removeItem(uri);
				return;
			}
			this._GET(uri, (result) => {
				this.spendingPlansFull = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ !refreshCache, /* forceSetCache: */ refreshCache);
		},

		_getSavingGoals: function (onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/SavingsGoals", (result) => {
				this.savingGoals = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},
		_clearSavingGoals: function () {
			localStorage.removeItem(this.api + (this.useCachedEndpoints ? '/Cached' : '') + '/Customers/00000000-0000-0000-0000-000000000000/SavingsGoals');
		},

		_getSavingGoal: function (id, onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/SavingsGoals/" + id, (result) => {
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_deleteSavingGoal: function (id, onSuccess = null) {
			this.$http.delete(this.api + "/Customers/00000000-0000-0000-0000-000000000000/SavingsGoals/" + id)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._deleteSavingGoal(id, onSuccess);
						});
					}
				});
		},

		_quoteSavingGoal: function (goal, onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/SavingsGoals/BankAccounts/" + goal.bankAccountID + "/Quotes", goal)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._quoteSavingGoal(goal, onSuccess);
						});
					}
				});
		},

		_createSavingGoal: function (goal, onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/SavingsGoals/", goal)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._createSavingGoal(goal, onSuccess);
						});
					}
				});
		},

		_getInsuranceInfo: function (onSuccess = null, refreshCache = false) {
			var uri = this.api + (this.useCachedEndpoints ? '/Cached' : '') + "/Customers/00000000-0000-0000-0000-000000000000/Policies";
			if (refreshCache) {
				localStorage.removeItem(uri);
				return;
			}
			this._GET(uri, (result) => {
				this.insuranceInfo = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ !refreshCache, /* forceSetCache: */ refreshCache);
		},

		_getInsuranceProviders: function (onSuccess = null) {
			this._GET("/InsuranceProviders", (result) => {
				this.insuranceProviders = result;
				if (onSuccess) {
					onSuccess(result);
				}
			});
		},

		_getInvestmentProviders: function (onSuccess = null) {
			this._GET("/InvestmentProviders", (result) => {
				this.investmentProviders = result;
				if (onSuccess) {
					onSuccess(result);
				}
			});
		},

		_getMortgageInfo: function (onSuccess = null, refreshCache = false) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts/Mortgages", (result) => {
				this.mortgageInfo = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ !refreshCache, /* forceSetCache: */ refreshCache);
		},

		_getMortgage: function (policyId, onSuccess = null, refreshCache = false) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts/Mortgages/" + policyId, (result) => {
				this.policy = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ !refreshCache, /* forceSetCache: */ refreshCache);
		},

		_getInvestmentAccount: function (id, onSuccess = null, refreshCache = false) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/InvestmentHubAccounts/" + id, (result) => {
				this.investmentAccount = result;
				//console.log(this.investmentAccount, 'Investment Account');
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ !refreshCache, /* forceSetCache: */ refreshCache);
		},

		_deleteInvestmentAccount: function (id, onSuccess = null) {
			this.$http.delete(this.api + "/Customers/00000000-0000-0000-0000-000000000000/InvestmentHubAccounts/" + id)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					console.log(result, 'ERROR CAUGHT');
				});
		},

		_getInvestmentInfo: function (onSuccess = null, refreshCache = false, cleareCache = false) {
			var uri = this.api + (this.useCachedEndpoints ? '/Cached' : '') + "/Customers/00000000-0000-0000-0000-000000000000/InvestmentHubAccounts";
			if (cleareCache) {
				localStorage.removeItem(uri);
				return;
			}
			this._GET(uri, (result) => {
				this.investmentInfo = result;
				//console.log(this.investmentInfo);
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ !refreshCache, /* forceSetCache: */ refreshCache);
		},

		_getCmsArticles: function (tags = null, onSuccess = null) {
			this._GET("/CMS/Articles?tags=" + (tags ?? ''), (result) => {
				this.articles = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ true);
		},

		_getCmsArticleByKey: function (key, onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/CMS/Articles/SearchRequests?key=" + key, null)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data.length > 0 ? response.data[0].article : null);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._getCmsArticleByKey(key, onSuccess);
						});
					}
				});
		},

		_getCmsArticle: function (id, onSuccess = null) {
			if (id.split('-').length != 5) {
				return this._getCmsArticleByKey(id, (result) => {
					this.article = result;
					if (onSuccess) {
						onSuccess();
					}
				});
			}
			else {
				this._GET("/CMS/Articles/" + id, (result) => {
					this.article = result;
					if (onSuccess) {
						onSuccess();
					}
				}, /* useCache: */ true);
			}
		},

		_getWalkthrough: function (key, onSuccess = null) {
			this._GET("/CMS/Walkthroughs/Keys/" + key, (result) => {
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_getQuizzes: function (onlyTodaysQuizzes, todaysQuestionsOnly, tomorrowsQuestionsOnly, onSuccess = null) {
			this._GET("/Quizzes?onlyTodaysQuizzes=" + onlyTodaysQuizzes + "&todaysQuestionsOnly=" + todaysQuestionsOnly + "&tomorrowsQuestionsOnly=" + tomorrowsQuestionsOnly, (result) => {
				this.quizzes = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ true);
		},

		_getQuizPoints: function (quizId, onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Quizzes/" + quizId + "/Points", (result) => {
				this.quizPoints = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_getQuizAnswers: function (quizId, onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Quizzes/" + quizId + "/Answers", (result) => {
				this.quizAnswers = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_clearQuizCache: function (quizId) {
			const quizCacheKey = this.api + "/Customers/00000000-0000-0000-0000-000000000000/Quizzes/" + quizId;
			localStorage.removeItem(quizCacheKey + "/Answers");
			localStorage.removeItem(quizCacheKey + "/Points");
		},

		_postQuizAnswer: function (quizId, questionId, answerId, onSuccess = null) {
			var requestBody = {
				"quizId": quizId,
				"customerId": "00000000-0000-0000-0000-000000000000",
				"questionId": questionId,
				"answerId": answerId
			};
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Quizzes/" + quizId + "/Answers", requestBody)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				})
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._postQuizAnswer(quizId, questionId, answerId, onSuccess);
						});
					}
				});
		},

		_getQuestionnaireByGuidOrKey: function (id, onSuccess = null) {
			if (id.match(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/)) {
				this._getQuestionnaire(id, onSuccess);
			} else {
				this._getQuestionnaireByKey(id, (result) => {
					this.questionnaire = result;
					if (onSuccess) {
						onSuccess();
					}
				});
			}
		},

		_getQuestionnaire: function (id, onSuccess = null) {
			this._GET("/Questionnaires/" + id, (result) => {
				this.questionnaire = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ true);
		},

		_getQuestionnaireByKey: function (key, onSuccess = null) {
			this.$http.post(this.api + "/Questionnaires/Searches/" + key, null)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._getQuestionnaireByKey(key, onSuccess);
						});
					}
				});
		},

		_getQuestionnaireAnswers: function (id, onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/CustomerAnswers", (result) => {
				this.questionnaireAnswers = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ false);
		},

		_saveQuestionnaireAnswer: function (question, onSuccess = null) {
			const requestBody = [];
			if (!question.question.selectedAnswer) {
				return;
			}
			question.question.selectedAnswer.forEach(selectedAnswer => {
				var answer = {
					"questionID": question.questionId,
				};
				if (selectedAnswer.answerId) {
					answer.answerID = selectedAnswer.answerId;
				}
				if (selectedAnswer.amount != undefined && selectedAnswer.amount != null) {
					answer.freeAnswer = String(selectedAnswer.amount);
				}
				requestBody.push(answer);
			});
			if (requestBody.length == 0) {
				return;
			}
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/CustomerAnswers", requestBody)
				.then((result) => {
					if (onSuccess) {
						//console.log('Saved questionnaire answer, response was ', result.data);
						onSuccess(result.data);
					}
				}
				)
				.catch((result) => {
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._saveQuestionnaireAnswer(question, onSuccess);
						});
					}
				});
		},

		_generateFinacialFitness: function (onSuccess = null, clearCache = false) {
			var uri = this.api + "/Customers/00000000-0000-0000-0000-000000000000/FinancialFitness/GenerateRequests";
			if (clearCache) {
				localStorage.removeItem(uri);
				return;
			}
			this.$http.post(uri, null)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._generateFinacialFitness(onSuccess);
						});
					}
				});
		},

		_getBenefits: function (onSuccess = null, benefitsRequest) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Benefits", {
				relationshipStatus: benefitsRequest.relationshipStatus,
				dob: benefitsRequest.dob,
				childrenNum: benefitsRequest.childrenNum,
				housingType: benefitsRequest.housingType,
				postcode: benefitsRequest.postcode,
				monthlyIncomeAmount: benefitsRequest.monthlyIncomeAmount,
				monthlyBenefitsAmount: benefitsRequest.monthlyBenefitsAmount
			})
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				})
				.catch((result) => {
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._getBenefits(onSuccess, benefitsRequest);
						});
					}
				});
		},

		_getLatestFinancialFitness: function (onSuccess = null) {
			this._getFinancialFitness((l) => {
				this.financialFitness = l[0];
				if (onSuccess) {
					onSuccess(l[0]);
				}
			});
		},

		_getFinancialFitness: function (onSuccess = null, clearCache = false) {
			var uri = this.api + (this.useCachedEndpoints ? '/Cached' : '') + "/Customers/00000000-0000-0000-0000-000000000000/FinancialFitness";
			if (clearCache) {
				localStorage.removeItem(uri);
				return;
			}
			this._GET(uri, (result) => {
				this.financialFitnessHistory = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},
		_clearFinancialFitness: function () {
			localStorage.removeItem(this.api + (this.useCachedEndpoints ? '/Cached' : '') + '/Customers/00000000-0000-0000-0000-000000000000/FinancialFitness');
		},

		_getPlans: function (onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Plans", (result) => {
				this.plans = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ true);
		},

		_getPlan: function (id, onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Plans/" + id, (result) => {
				this.plan = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ true);
		},

		_getPlanSection: function (id, onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Plans/Sections/" + id, (result) => {
				this.planSection = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ true);
		},

		_getPlanTask: function (id, onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Plans/Sections/Tasks/" + id, (result) => {
				this.planTask = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ true);
		},
		_clearPlan: function () {
			console.log('Clearing plans cache');
			Object.keys(localStorage).forEach(key => {
				if (key.includes('/Plans')) {
					localStorage.removeItem(key);
				}
			});
		},

		_setPlanTaskCompleted: function (taskId, completed, onSuccess = null) {
			var request = { "completed": completed };
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Plans/Sections/Tasks/" + taskId + "/SetStatusRequests", request)
				.then((response) => {
					this._clearPlan();
					if (onSuccess) {
						onSuccess(response);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._setPlanTaskCompleted(taskId, completed, onSuccess);
						});
					}
				});
		},

		_getAvailableVouchers: function (onSuccess = null) {
			if (this.availableVouchers && this.availableVouchers.length > 0) {
				if (onSuccess) {
					onSuccess();
				}
				return;
			}
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/AvailableDiscounts", (result) => {
				this._GET("/Customers/00000000-0000-0000-0000-000000000000/Discounts/Favourites", (f) => {
					this.favouriteDiscounts = f;
					this.availableVouchers = Array.isArray(result) ? result : [];
					this.availableVouchers.forEach(v => {
						v.favourite = this.favouriteDiscounts.some(f => f.id == v.id);
					});
					if (onSuccess) {
						onSuccess();
					}
				}, /* useCache: */ true);
			}, /* useCache: */ true);
		},

		_getCustomerFavouriteVouchers: function (onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Discounts/Favourites", (result) => {
				this.favouriteDiscounts = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},
		_clearCustomerFavouriteVouchers: function () {
			localStorage.removeItem(this.api + (this.useCachedEndpoints ? '/Cached' : '') + '/Customers/00000000-0000-0000-0000-000000000000/Discounts/Favourites');
		},

		_addCustomerFavouriteDiscount: function (discount, onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Discounts/Favourites/", discount)
				.then(() => {
					this._clearCustomerFavouriteVouchers();
					if (onSuccess) {
						onSuccess();
					}
				});
		},

		_removeCustomerFavouriteDiscount: function (discount, onSuccess = null) {
			this.$http.delete(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Discounts/Favourites/" + discount.id)
				.then(() => {
					this._clearCustomerFavouriteVouchers();
					if (onSuccess) {
						onSuccess();
					}
				});
		},

		_searchAvailableVouchers: function (search, onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/AvailableDiscounts?search=" + search, (result) => {
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_getVoucherRecommendations: function (daysBack = -90, onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Discounts?daysBack=" + daysBack, (result) => {
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_getDiscountsStatement: function (onSuccess = null, useCache = false, forceSetCache = false) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Discounts/Statement", (result) => {
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ useCache, /* forceSetCache: */ forceSetCache);
		},

		//TODO: This will be a service method
		_createCart: function (cartData) {
			console.log('Saving cart', cartData);
			sessionStorage.setItem('voucherCart', JSON.stringify(cartData));
		},

		//TODO: This will be a service method
		_getCart: function (onSuccess = null) {
			var cart = sessionStorage.getItem('voucherCart');
			if (cart) {
				if (onSuccess) {
					onSuccess(JSON.parse(cart));
				}
			} else {
				if (onSuccess) {
					onSuccess({ items: [] });
				}
			}
		},

		_deleteCart: function () {
			sessionStorage.removeItem('voucherCart');
		},

		_getRecommendedVouchers: function (daysBack = -90, onSuccess = null) {
			this._getAvailableVouchers(() => {
				this._getVoucherRecommendations(daysBack, (r) => {
					var recommended = r;
					var recommendedVouchers = this.availableVouchers.filter(v => {
						return recommended.some(r => r.merchantId == v.merchant.sysoMerchantId);
					});
					recommendedVouchers.forEach(v => {
						v.spent = r.filter(r => r.merchantId == v.merchant.sysoMerchantId)[0].amount;
						v.saving = r.filter(r => r.merchantId == v.merchant.sysoMerchantId)[0].savingRounded;
						v.biggestSaving = r.filter(r => r.merchantId == v.merchant.sysoMerchantId)[0].biggestSpend;
						v.lastMonthSpend = r.filter(r => r.merchantId == v.merchant.sysoMerchantId)[0].lastMonthSpend;
						v.transactionCount = r.filter(r => r.merchantId == v.merchant.sysoMerchantId)[0].transactionCount;
						v.discountCategory = r.filter(r => r.merchantId == v.merchant.sysoMerchantId)[0].discountCategory;
					});
					recommendedVouchers.sort((a, b) => b.saving - a.saving);
					if (onSuccess) {
						onSuccess(recommendedVouchers);
					}
				});
			})

		},

		_getAvailableVoucher: function (id, onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/AvailableDiscounts/" + id, (result) => {
				this.availableVoucher = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_getCategories: function (onSuccess = null) {
			this._GET("/Discounts/Categories", (result) => {
				this.categories = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ true);
		},

		_getCustomerVouchersGroupedByMerchant: function (onSuccess = null, archived = null, useCache = false, forceSetCache = false) {
			let url = "/Customers/00000000-0000-0000-0000-000000000000/Vouchers/MerchantGroups";
			if (archived !== null) {
				url += "?archived=" + archived;
			}
			this._GET(url, (result) => {
				this.groupedVouchers = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ useCache, /* forceSetCache: */ forceSetCache);
		},

		_getCustomerVouchersSummary: function (onSuccess = null, useCache = false, forceSetCache = false) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Vouchers/Summary", (result) => {
				this.vouchersSummary = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ useCache, /* forceSetCache: */ forceSetCache);
		},

		_getCustomerVouchers: function (onSuccess = null, merchantId = null, archived = null, useCache = false, forceSetCache = false) {
			let url = "/Customers/00000000-0000-0000-0000-000000000000/Vouchers";
			if (merchantId) {
				url += "?merchantId=" + merchantId;
			}
			if (archived !== null) {
				url += (merchantId ? "&" : "?") + "archived=" + archived;
			}
			this._GET(url, (result) => {
				this.vouchers = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ useCache, /* forceSetCache: */ forceSetCache);
		},

		_getCustomerVoucher: function (id, onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Vouchers/" + id, (result) => {
				this.voucher = result;
				if (onSuccess) {
					onSuccess();
				}
			});
		},
		_clearCustomerVouchers: function () {
			console.log('Clearing voucher cache');
			Object.keys(localStorage).forEach(key => {
				if (key.includes('/Customers/00000000-0000-0000-0000-000000000000/Vouchers')) {
					localStorage.removeItem(key);
				}
			});
		},

		_getPayment: function (paymentId, onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Payments?providerPaymentId=" + paymentId, (result) => {
				this.payment = result;
				if (onSuccess) {
					onSuccess();
				}
			});
		},

		_createPayment: function (paymentRequest, onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Payments", paymentRequest)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._createPayment(paymentRequest, onSuccess);
						});
					}
				});
		},

		_orderVoucher: function (slug, amount, paymentId, onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Vouchers?brandSlug=" + slug + "&amount=" + amount + "&paymentId=" + paymentId, null)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._orderVoucher(slug, amount, paymentId, onSuccess);
						});
					}
				});
		},

		_deleteVoucherTransaction: function (voucherId, transactionId, onSuccess = null) {
			this.$http.delete(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Vouchers/" + voucherId + "/Transactions/" + transactionId)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._deleteVoucherTransaction(voucherId, transactionId, onSuccess);
						});
					}
				});
		},

		_updateVoucherTransaction: function (voucherId, transactionId, amount, onSuccess = null) {
			const requestBody = {
				amount: amount
			};
			this.$http.put(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Vouchers/" + voucherId + "/Transactions/" + transactionId, requestBody)
				.then(() => {
					if (onSuccess) {
						onSuccess();
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._updateVoucherTransaction(voucherId, transactionId, amount, onSuccess);
						});
					}
				});
		},

		_addVoucherEaseOfUse: function (easeOfUseData, onSuccess = null) {
			this.$http.put(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Vouchers/" + easeOfUseData.id + "/Ease", easeOfUseData.score, {
				headers: {
					'Content-Type': 'application/json',
					'accept': 'text/plain'
				}
			})
				.then(() => {
					if (onSuccess) {
						onSuccess();
					}
				})
				.catch((result) => {
					console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._addVoucherEaseOfUse(easeOfUseData, onSuccess);
						});
					}
				});
		},

		_archiveVoucher: function (id, onSuccess = null) {
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Vouchers/Archived/" + id, {
				headers: {
					'Content-Type': 'application/json',
					'accept': 'text/plain'
				}
			})
				.then(() => {
					if (onSuccess) {
						onSuccess();
					}
				})
				.catch((result) => {
					console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._archiveVoucher(id, onSuccess);
						});
					}
				});
		},

		_unarchiveVoucher: function (id, onSuccess = null) {
			this.$http.delete(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Vouchers/Archived/" + id, {
				headers: {
					'Content-Type': 'application/json',
					'accept': 'text/plain'
				}
			})
				.then(() => {
					if (onSuccess) {
						onSuccess();
					}
				}
				)
				.catch((result) => {
					console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._unarchiveVoucher(id, onSuccess);
						});
					}
				});
		},

		_addVoucherTransaction: function (id, amount, onSuccess = null) {
			const requestBody = {
				amount: amount
			};
			this.$http.post(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Vouchers/" + id + "/Transactions", requestBody)
				.then((response) => {
					if (onSuccess) {
						onSuccess(response.data);
					}
				}
				)
				.catch((result) => {
					//console.log(result, 'ERROR CAUGHT');
					if (result.response.status == 401) {
						this._refreshLogin(() => {
							this._addVoucherTransaction(id, amount, onSuccess);
						});
					}
				});
		},

		_getPolicy: function (policyId, onSuccess = null, refreshCache = false) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Policies/" + policyId, (result) => {
				this.policy = result;
				//console.log('Policy', this.policy);
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ !refreshCache, /* forceSetCache: */ refreshCache);
		},

		_deletePolicy: function (policyId, onSuccess = null) {
			this.$http.delete(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Policies/" + policyId)
				.then(() => {
					if (onSuccess) {
						onSuccess();
					}
				}
				);
		},

		_getPersonalNews: function (onSuccess = null, allowRetry = true) {
			this.$http.get(this.api + "/Customers/00000000-0000-0000-0000-000000000000/News")
				.then(
					(result) => {
						if (onSuccess) {
							onSuccess(result.data);
						}
					}
				)
				.catch(
					(result) => {
						if (result.response && result.response.status == 401) {
							this._refreshLogin(() => {
								this._getPersonalNews(onSuccess, true);
							});
						}
						else if (result.response && result.response.status == 503) {
							if (allowRetry) {
								onSuccess("I'm still working on that 💭💭 It Shouldn't be too much longer. Hang tight!", true);
								setTimeout(() => { this._getPersonalNews(onSuccess, false); }, 15000);
							}
							else {
								onSuccess("Sorry, something went wrong while generating your news.  That's embarrasing... 😬 Please try again later.");
							}
						}
						else if (result.code == 'ERR_NETWORK') {
							if (allowRetry) {
								onSuccess("I'm still working on that 💭💭 It Shouldn't be too much longer. Hang tight!", true);
								setTimeout(() => { this._getPersonalNews(onSuccess, false); }, 15000);
							}
							else {
								onSuccess("Sorry, something went wrong while generating your news.  That's embarrasing... 😬 Please try again later.");
							}
						}
					}
				);
		},

		_getDocumentsByHubId: function (hubItemId, onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Documents/HubItems/" + hubItemId, (result) => {
				this.documents = result;
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ true);
		},

		_getDocuments: function (onSuccess = null, refreshCache = false) {
			if (refreshCache) {
				localStorage.removeItem(this.api + (this.useCachedEndpoints ? '/Cached' : '') + "/Customers/00000000-0000-0000-0000-000000000000/Documents");
			}
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Documents", (result) => {
				this.documents = result.filter(d => d.processedMeta != null);
				this.documents.forEach((doc) => {
					if (doc.price && doc.price.includes("£")) {
						doc.price = doc.price.replace("£", "");
					}
					doc.createDateTimeString = this._csharpDateTimetoDateTime(doc.createDateTime);
				});
				if (onSuccess) {
					onSuccess();
				}
			}, /* useCache: */ true);
		},
		_clearDocuments: function () {
			localStorage.removeItem(this.api + (this.useCachedEndpoints ? '/Cached' : '') + '/Customers/00000000-0000-0000-0000-000000000000/Documents');
		},

		_getDocument: function (documentId, onSuccess = null, refreshCache = false) {
			if (refreshCache) {
				localStorage.removeItem(this.api + (this.useCachedEndpoints ? '/Cached' : '') + "/Customers/00000000-0000-0000-0000-000000000000/Documents/" + documentId);
			}
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Documents/" + documentId, (result) => {
				if (onSuccess) {
					console.log(result, 'result');
					result.wellData = JSON.parse(result.processedMeta);
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_getCustomerTags: function (onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/CustomerTags", (result) => {
				this.customerTags = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_getTransactionsForCustomerTag: function (tagId, onSuccess = null) {
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/CustomerTags/" + tagId + "/Transactions", (result) => {
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_deleteDocument: function (documentId, onSuccess = null) {
			this.$http.delete(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Documents/" + documentId)
				.then(() => {
					if (onSuccess) {
						onSuccess();
					}
				}
				);
		},

		_updateDocument: function (document, onSuccess = null) {
			this.$http.put(this.api + "/Customers/00000000-0000-0000-0000-000000000000/Documents/" + document.id, document)
				.then(() => {
					this._clearDocuments();
					localStorage.removeItem(this.api + (this.useCachedEndpoints ? '/Cached' : '') + "/Customers/00000000-0000-0000-0000-000000000000/Documents/" + document.id);
					if (onSuccess) {
						onSuccess();
					}
				}
				);
		},

		_removeUnavailableDiscountProviders: function (voucher) {
			if (voucher.stackWith) {
				voucher.stackWith.forEach(r => {
					this._useDiscountProvider(r, (use) => {
						if (!use) {
							voucher.stackWith.pop(r);
						}
					});
				});
			}
		},

		_updateTransactionTags: function (bankAccountId, transactionId, tags, onSuccess = null) {
			const transactionTags = tags.map(t => t.id ? { "tag": t.tag, "id": t.id } : { "tag": t.tag || t });

			this.$http.put(this.api + "/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/" + bankAccountId + "/Transactions/" + transactionId + "/CustomerTags", transactionTags)
				.then(() => {
					if (onSuccess) {
						onSuccess();
					}
				}
				);
		},
		_clearCustomerTagsCache: function () {
			for (let i = 0; i < localStorage.length; i++) {
				const key = localStorage.key(i);
				if (key && key.includes('/CustomerTags')) {
					localStorage.removeItem(key);
					i--; // Adjust the index after removing an item
				}
			}
		},

		_useDiscountProvider: function (provider, onSuccess = null) {
			var existing = localStorage.getItem('LinkedDiscountProviders');
			if (existing == null) {
				existing = [];
				this._getBlueLightCard(() => {
					existing = localStorage.getItem('LinkedDiscountProviders');
					if (onSuccess) {
						onSuccess(existing.indexOf(provider) != -1);
					}
				});
			}
			else {
				if (onSuccess) {
					onSuccess(existing.indexOf(provider) != -1);
				}
			}
		},

		_getBlueLightCard: function (onSuccess = null) {
			var existing = JSON.parse(localStorage.getItem('LinkedDiscountProviders'));
			if (existing == null) {
				existing = [];
			}
			localStorage.setItem('LinkedDiscountProviders', JSON.stringify(existing));
			this._GET("/Customers/00000000-0000-0000-0000-000000000000/Documents/BlueLightCard", (result) => {
				if (result && result != "") {
					if (existing.indexOf("Blue Light Card") == -1) {
						existing.push("Blue Light Card");
						localStorage.setItem('LinkedDiscountProviders', JSON.stringify(existing));
					}
				}
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_getLastChatMessage: function (onSuccess = null) {
			this._GET("/Chats/Messages?customerId=" + this.customer.id, (result) => {
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ false);
		},

		_pollForChatResponse: function (lastMessageId, onSuccess = null) {
			setTimeout(() => {
				this._getLastChatMessage((lastMessage) => {
					if (lastMessage && lastMessage.length > 0 && lastMessage[0].id != lastMessageId && lastMessage[0].direction == "OUT") {
						if (onSuccess) {
							onSuccess(lastMessage[0]);
						}
					}
					else {
						this._pollForChatResponse(lastMessageId, onSuccess);
					}
				});
			}, 5000);
		},

		_sendChatMessage: function (message, onSuccess = null, allowRetry = true) {
			var lastMessageId = null;
			this._getLastChatMessage((lastMessage) => {
				if (lastMessage && lastMessage.length > 0) {
					lastMessageId = lastMessage[0].id;
				}
				this.$http.post(this.api + "/Chats/ChatRequests?customerID=" + this.customer.id, {
					"body": message
				})
				.then((result) => {
					if (onSuccess) {
						onSuccess(result.data);
					}
				})
				.catch((result) => {
					console.log(result, 'ERROR CAUGHT');
					if (result.response && result.response && result.response.status == 401) {
						this._refreshLogin(() => {
							this._sendChatMessage(message, onSuccess);
						});
					}
					else if (result.response && result.response.status == 503) {
						if (allowRetry) {
							onSuccess({ body: "I'm still working on that 💭💭 Just a moment!", keepThinking: true });
							this._pollForChatResponse(lastMessageId, onSuccess); 
						}
						else {
							onSuccess({ body: "Sorry, I can't help you with that right now." });
						}
					}
					else if (result.code == 'ERR_NETWORK') {
						if (allowRetry) {
							onSuccess({ body: "I'm still working on that 💭💭 Just a moment!", keepThinking: true });
							this._pollForChatResponse(lastMessageId, onSuccess); 
						}
						else {
							onSuccess({ body: "Sorry, I can't help you with that right now." });
						}
					}
				});
			});
		},

		_sendSessionlessChatMessage: function (message, onSuccess = null) {
			this.$http.post(this.api + "/Chats/ChatRequestsEx", {
				"body": message
			})
			.then((result) => {
				if (onSuccess) {
					onSuccess(result.data);
				}
			}
			)
		},

		_clearHttpCache: function () {
			for (let i = 0; i < localStorage.length; i++) {
				const key = localStorage.key(i);
				if (key && key.includes('https://')) {
					localStorage.removeItem(key);
					i--;
				}
			}
		},

		_login: function (email, password, onSuccess = null) {
			this.$http.post(this.api + "/Sessions", {
				"userName": email,
				"password": password
			})
				.then((result) => {
					try {

						this.token = result.data.session.token;
						this.$cookies.set('token', result.data.session.token, '30min');
						this.$http.defaults.headers.common = { "Authorization": "bearer " + this.token };
						if (onSuccess) {
							onSuccess(true);
						}
					}
					catch {
						if (onSuccess) {
							onSuccess(false);
						}
					}
				}
			);
		},

		_refreshLogin: function (onSuccess = null) {
			if (!this.$cookies.get('user') || !this.$cookies.get('pass')) {
				window.location.href = "/MG_POP.html";
			}
			var email = this.$cookies.get('user');
			var password = this.$cookies.get('pass');
			this._login(email, password, onSuccess);
		},

		_getAiopSection: function (sectionName, onSuccess = null) {
			var orig = this.$http.defaults.headers.common;
			this.$http.defaults.headers.common = null;
			this.$http.get(this.aiopSectionsS3Bucket + sectionName)
				.then((result) => {
					this.sectionJson = result.data.sections;
					if (onSuccess) {
						onSuccess();
					}
				})
				.catch(() => {
					// Fallback to local file if S3 request fails
					import(/* webpackExclude: /__tests__/ */ '../components/' + sectionName)
						.then((module) => {
							this.sectionJson = module.default.sections;
							console.log(this.sectionJson, 'this.sectionJson');
							if (onSuccess) {
								onSuccess();
							}
						})
						.catch((error) => {
							console.error('Failed to load both S3 and local section file:', error);
							if (onSuccess) {
								onSuccess();
							}
						});
				});
			this.$http.defaults.headers.common = orig;
		},

		_peekingDrawerBottom: function () {
			var c = this.$cookies.get('sb');
			var ret = 44;
			if (c) {
				ret += parseInt(c);
			}
			return ret + 'px';
		},

		_peekingDrawerBottom_NoMenu: function () {
			//var c = this.$cookies.get('sb');
			var ret = -10;
			// if (c) {
			// 	ret += parseInt(c);
			// }
			return ret + 'px';
		},

		_closedDrawerHeightNoMenu: function () {
			return (60 + (this.$cookies.get('sb') ? parseInt(this.$cookies.get('sb')) : 0)) + 'px';
		},

		_getFaqs: function (name = null, onSuccess = null) {
			this._GET("/Faq/Name/" + (name ? name : ""), (result) => {
				this.faqs = result;
				if (onSuccess) {
					onSuccess(result);
				}
			}, /* useCache: */ true);
		},

		_createFaq: function (faqData, onSuccess = null) {
			this.$http.post(this.api + '/Faq', faqData)
				.then((response) => {
					if (onSuccess) onSuccess(response.data);
				});
		}

	}
}